// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"cf0c832e","357":"11c08786","375":"5d5e5618"}[chunkId] + ".chunk.css";
};